"use client";
import { whyJoinUsItems } from "@/data/career.data";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { useDict } from "@/components/providers/LocaleProvider";

const WhyJoinUs = () => {
  const t = useDict();
  return (
    <section className="px-[5%] p-10 flex gap-y-4 flex-col justify-center items-center space-y-4 bg-gradient-to-br from-primary/40 to-black/50">
      <h2 className="section-title">{t.careersPage.whyJoinUs.title}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-center gap-6">
        {whyJoinUsItems.map(({ key, icon }) => {
          const item = t.careersPage.whyJoinUs.points[key];
          return (
            <div
              key={key}
              className="bg-white p-5 rounded-2xl cursor-pointer transition-all duration-300 ease-in-out transform hover:scale-104 shadow-lg hover:shadow-xl shadow-white/20 flex items-center"
            >
              <section className="flex  items-center gap-4">
                <Image
                  src={icon}
                  alt={item.title}
                  width={45}
                  height={45}
                  className=" object-center"
                />
                <div className=" flex items-start gap-4">
                  <div className=" space-y-1 text-black">
                    <p className="card-title">
                      <strong className=" font-semibold">{item.title}</strong>
                    </p>
                    <p className="card-description">{item.description}</p>
                  </div>
                </div>
              </section>
            </div>
          );
        })}
      </div>

      <div>
        <Link
          href={"#career-job-posts"}
          className="bg-primary text-xl text-white py-2 px-6 rounded-full hover:bg-secondary transition cursor-pointer"
        >
          {t.careersPage.whyJoinUs.joinUsCta}
        </Link>
      </div>
    </section>
  );
};

export default WhyJoinUs;
